import React, { useEffect, useState , forwardRef, useImperativeHandle} from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { Link, useLocation, useNavigate } from "react-router";
import PaymentForm from "../../accountSettings/payment-methods/paymentFormNew";
import styles from "../../../../styles/paymentBlock.module.scss";
import OverlayLoader from "../../../loader/overlayLoader";
import Loader from "../../../loader";
const PaymentBlock = forwardRef(({ paymentDataProp, onSubmit: parentOnSubmit, totalAmountPrePay, salesAgreementNumbers, isParentLoading }, ref) => {
  const [isLoading, setIsLoading] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState("");
  const [successMessage, setSuccessMessage] = useState(null);
  const nav = useNavigate();
  const loc = useLocation();

  // This makes the setter function (and other methods) available to the parent
  useImperativeHandle(ref, () => ({
    updateIsLoading: (bool) => {
      setIsLoading(bool);
    }
  }))
 
  const customerSummary = useSelector((state) => state.login.customerInfo);

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsLoading(true);
    
    if (selectedMethod === "new") {
      setIsLoading(false);
      return;
    }
    
    if (parentOnSubmit && selectedMethod && (Array.isArray(salesAgreementNumbers.value) && salesAgreementNumbers.value.length > 0)) {
      const selected = paymentDataProp.find(
        (m) => m.pccTokenNum === selectedMethod
      );
      parentOnSubmit(selected, customerSummary[0] || null, false);
      return;
    }
    
    setIsLoading(false);
    return false;
  };

  return (
    paymentDataProp == null ? <><Loader /></> : <div>
      <>
        {isLoading && (
          <div
            className={styles.loaderOverlay}
            role="status"
            aria-live="polite"
            aria-busy="true"
          >
            <OverlayLoader isOpen={isLoading} />
          </div>
        )}
        <h3 className={styles.title}>Choose a payment method</h3>
         <form >
            {paymentDataProp && paymentDataProp.map((method, index) => (
              <div key={method.pccSid || index} className={`${styles['paymentMethod-border']} mb-10`}>
                <input
                  type="radio"
                  name="paymentMethod"
                  value={method.pccTokenNum}
                  checked={selectedMethod === method.pccTokenNum}
                  onChange={(e) => setSelectedMethod(e.target.value)}
                  className={styles.checkbox}
                />
                <label className={styles.label}>
                  {method.pccPaymentType} ending in {method.pccAcctLast4}
                </label>
              </div>
            ))}

            <div className={`${styles['paymentMethod-border']} mb-10`}>
              <input
                type="radio"
                name="paymentMethod"
                value="new"
                className={styles.checkbox}
                checked={selectedMethod === "new"}
                onChange={(e) => setSelectedMethod(e.target.value)}
              />
              <label className={styles.label}>
                New payment method (Debit/Credit card or Bank account)
              </label>
            </div>

            {selectedMethod !== "new" && <div className={styles.paymentActions}>
              <Link
                to="/my-account/account-settings/easypay-settings"
                className={styles.cancelButton}
              >
                Cancel
              </Link>
              <button type="button" disabled={selectedMethod == "" || (Array.isArray(salesAgreementNumbers.value) && salesAgreementNumbers.value.length == 0)} onClick={(e) => handleSubmit(e)} className={styles.submitButton}>
                Submit
              </button>
            </div>}
          </form>
        {selectedMethod === "new" && 
          // Render PaymentForm separately (it has its own form)
          <PaymentForm 
            salesAgrmtObj={salesAgreementNumbers}
            totalAmount={totalAmountPrePay}
            onSubmit={parentOnSubmit}
            flag={'prePayPayment'}
          />
        }
      </>
    </div>
  );
})

PaymentBlock.propTypes = {
  paymentDataProp: PropTypes.array.isRequired,
  onSubmit: PropTypes.func,
};

export default PaymentBlock;
